import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "../../layout/Footer/Footer";
import Navbar from "../../layout/Navbar/Navbar";
import "../Privacy/PrivacyStyles.scss";
import "./CookiesStyles.scss";

function Cookies() {
	const { t } = useTranslation();

	useEffect(() => {
		document.title = `${t("cookiePolicy.pageTitle")} | GLuck Esports`;
		window.scrollTo(0, 0);
	}, [t]);

	const sections = t("cookiePolicy.sections", { returnObjects: true });
	const intro = t("cookiePolicy.intro", { returnObjects: true });
	const tableHeaders = t("cookiePolicy.table.headers", { returnObjects: true });
	const tableRows = t("cookiePolicy.table.rows", { returnObjects: true });

	return (
		<section id="cookies" className="privacy-page cookies-page">
			<Navbar isVisible={true} />
			<div className="privacy__container">
				<header className="privacy__header">
					<h1>{t("cookiePolicy.title")}</h1>
					<p className="privacy__revision">{t("cookiePolicy.revision")}</p>
				</header>
				<div className="privacy__content">
					{Array.isArray(intro) &&
						intro.map((paragraph, index) => (
							<p key={`cookies-intro-${index}`} className="cookies-intro">
								{paragraph}
							</p>
						))}

					{Array.isArray(sections) &&
						sections.map((section) => (
							<article key={section.id} className="privacy__section">
								<h2>
									{section.id}. {section.heading}
								</h2>
								{section.paragraphs?.map((paragraph, index) => (
									<p key={`${section.id}-p-${index}`}>{paragraph}</p>
								))}
								{section.showTable && Array.isArray(tableRows) && (
									<div className="cookies-table-wrap">
										<table className="cookies-table">
											<thead>
												<tr>
													{Array.isArray(tableHeaders) &&
														tableHeaders.map((header) => (
															<th key={header}>{header}</th>
														))}
												</tr>
											</thead>
											<tbody>
												{tableRows.map((row) => (
													<tr key={row.name}>
														<td>
															<code>{row.name}</code>
														</td>
														<td>{row.purpose}</td>
														<td>{row.term}</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
								)}
								{section.list?.length > 0 && (
									<ul>
										{section.list.map((item, index) => (
											<li key={`${section.id}-li-${index}`}>{item}</li>
										))}
									</ul>
								)}
								{section.closing?.map((paragraph, index) => (
									<p key={`${section.id}-c-${index}`}>{paragraph}</p>
								))}
								{section.privacyLink && (
									<p>
										{section.privacyLink.before}{" "}
										<Link to="/privacy">{section.privacyLink.label}</Link>
										{section.privacyLink.after}
									</p>
								)}
							</article>
						))}
				</div>
			</div>
			<Footer alwaysVisible={true} />
		</section>
	);
}

export default Cookies;
